import { Strategy } from 'utility-ts-strategy';
export const ApPlanFeedbackEmphasizeEventNameStrategy = new Strategy({
  COURSE: (nk: string) => `APPlanFeedbackCourseHighlightEvent${nk.replace(/ /g, '_')}`,
  COURSE_GROUP: (nk: string) => `APPlanFeedbackCourseGroupHighlightEvent${nk.replace(/ /g, '_')}`
});
export const ApPlanFeedbackDeEmphasizeEventNameStrategy = new Strategy({
  COURSE: (nk: string) => `APPlanFeedbackCourseLowlightEvent${nk.replace(/ /g, '_')}`,
  COURSE_GROUP: (nk: string) => `APPlanFeedbackCourseGroupLowlightEvent${nk.replace(/ /g, '_')}`
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/suggestions/components/plan_feedback/strategies/plan_feedback_highlight_event_name_strategy.ts